export default function PhilosophySection() {
  return (
    <section className="relative w-full py-24 md:py-32 lg:py-40 bg-background-50">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="w-full lg:w-2/5">
            <div className="bg-accent-100 rounded-lg aspect-square flex items-center justify-center">
              <i className="ri-double-quotes-l text-7xl md:text-8xl text-accent-400"></i>
            </div>
          </div>
          <div className="w-full lg:w-3/5 space-y-8">
            <span className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-400 font-medium">
              Engineering Philosophy
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              Reliable systems built for the long term
            </h2>
            <blockquote className="border-l-2 border-accent-300 pl-6 md:pl-8">
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed italic">
                &ldquo;Every line of code we write is an investment in the future. We prioritize stability, maintainability, and technical integrity above short-term convenience — because the software we build today must serve its users reliably for years to come.&rdquo;
              </p>
            </blockquote>
            <p className="text-sm text-foreground-500 font-medium">
              &mdash; Engineering Standards
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}